import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { extractTenantsRolesFromUser } from '@utils/users';
import { uniq, values } from 'lodash';
import React from 'react';
import { IRole, IRolesTenantsMapping } from 'types/authorization';

const RolesCell: React.FC<GridRenderCellParams<any>> = ({ row }) => {
	const tenantsRolesMap = extractTenantsRolesFromUser(row);

	if (!tenantsRolesMap) {
		return null;
	}

	const tenants = uniq(values(tenantsRolesMap).map((v) => v.tenant));

	let value = '';
	let roles = [];
	let title = '';
	if (tenants.length <= 1) {
		const mappings = row.mappings || [];
		roles = mappings
			.map((m: IRolesTenantsMapping) => m.roles)
			.flat()
			.map((r: IRole) => r.name);

		value = uniq(roles).sort().join(', ');
		title = value;
	} else {
		value = intl.tr('users.roles.cell.multiple');
		roles = values(tenantsRolesMap).map((v) => v.role);
		title = uniq(roles).sort().join(', ');
	}

	return (
		<Typography
			color="text.secondary"
			variant="body2"
			title={title}
			data-testid="roles-cell"
		>
			{value}
		</Typography>
	);
};

export default RolesCell;
